import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import
{
  approveArchiveOrder,
  approveOrder,
  confirmOrderTaskingAdmin,
  createOrder,
  createTaskingOrder,
  getArchiveOrderById,
  getDataDownload,
  getDataUpload,
  getDetailOrderTaskingByAdmin,
  getDetailOrderTaskingByUer,
  getMetakeys,
  getOrderById,
  getOrderByIdUser,
  getOrderDetailByAdmin,
  getOrderDetailByUser,
  getPriority,
  getProduction,

  getProductTypeId,
  getSchemaCosmos,
  getSegmentsByIdOrder,
  getTaskingSchema,
  postNotiOrder,
  resendEmail,
  sendPriceToUser,
  sendQuotationToUser,
  sendToProvider,
  sendToProviderCapella,
  submitOrder,
  updateArchiveOrder,
  updateArchiveOrderByAdmin,
  updateStatusTaskingOrder,
  uploadData,
  getProductionSpectralProcessing,
  getOrderByIdAdmin,
  getOrder,
  getSchemaOrder,
  updateStatusOrder,
  getStatusOrder,
  updateOrder,
  getProvider,
  getSatellites,
  addOrder,
  getUrlDownloadItemOrder,
  getGeneralFormOrderArchive,
  getFormOrderArchiveByProviderCode
} from "../../services/orderServices";

interface IOrderState
{
  showDrawerListImages: boolean;
  showOrderTasking?: boolean;
  valuesForm?: any;
  orderedProvider?: any;
  polygonOrderTasking?: any;
  providerIdOrder?: any;

  filterDrawer?: {
    status: any;
    sortBy: "asc" | "desc";
    start_date?: number;
    end_date?: number;
    email?: string;
  };
  isFilter: any;
  nameProviderSelected?: any;
}

const initialState: IOrderState = {
  showDrawerListImages: false,
  showOrderTasking: false,
  valuesForm: {},
  orderedProvider: [],
  polygonOrderTasking: {},
  providerIdOrder: [],

  filterDrawer: {
    status: null,
    sortBy: "desc",
  },
  isFilter: false,
  nameProviderSelected: "",
};


export const updateOrderAsync = createAsyncThunk(
  "order/updateOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await updateOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getSchemaOrderAsync = createAsyncThunk<any>(
  "order/getSchemaOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await getSchemaOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getGeneralFormOrderArchiveAsync = createAsyncThunk<any>(
  "order/getGeneralFormOrderArchive",
  async () =>
  {
    try
    {
      const response = await getGeneralFormOrderArchive();
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getFormOrderArchiveByProviderCodeAsync = createAsyncThunk<any>(
  "order/getFormOrderArchiveByProviderCode",
  async (payload: any) =>
  {
    try
    {
      const response = await getFormOrderArchiveByProviderCode(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);



export const getOrderAsync = createAsyncThunk(
  "order/getOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getOrderDetailByUserAsync = createAsyncThunk(
  "order/getOrderDetailByUser",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrderDetailByUser(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getOrderDetailByAdminAsync = createAsyncThunk(
  "order/getOrderDetailByAdmin",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrderDetailByAdmin(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getProductTypeIdAsync = createAsyncThunk(
  "order/getProductTypeId",
  async (payload: any) =>
  {
    try
    {
      const response = await getProductTypeId(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);
export const approveArchiveOrderAsync = createAsyncThunk(
  "order/approveArchiveOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await approveArchiveOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const updateArchiveOrderAsync = createAsyncThunk(
  "order/updateArchiveOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await updateArchiveOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const updateArchiveOrderByAdminAsync = createAsyncThunk(
  "order/updateArchiveOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await updateArchiveOrderByAdmin(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getStatusOrderAsync = createAsyncThunk(
  "order/getStatusOrder",
  async () =>
  {
    try
    {
      const response = await getStatusOrder();
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const updateStatusOrderAsync = createAsyncThunk(
  "order/updateStatusOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await updateStatusOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);


export const getUrlDownloadItemOrderAsync = createAsyncThunk(
  "order/getUrlDownloadItemOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await getUrlDownloadItemOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);


export const getDetailOrderTaskingByUerAsync = createAsyncThunk(
  "order/getDetailOrderTaskingByUer",
  async (payload: any) =>
  {
    try
    {
      const response = await getDetailOrderTaskingByUer(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getDetailOrderTaskingByAdminAsync = createAsyncThunk(
  "order/getDetailOrderTaskingByAdmin",
  async (payload: any) =>
  {
    try
    {
      const response = await getDetailOrderTaskingByAdmin(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getOrderByIdUserAsync = createAsyncThunk(
  "order/getOrderByIdUser",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrderByIdUser(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);


export const getOrderByIdAdminAsync = createAsyncThunk(
  "order/getOrderByIdAdmin",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrderByIdAdmin(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getDataDownloadAsync = createAsyncThunk(
  "order/getDataDownload",
  async (payload?: any) =>
  {
    try
    {
      const response = await getDataDownload(payload?.orderId, payload?.orderDetailId);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getOrderByIdAsync = createAsyncThunk(
  "order/getOrderById",
  async (payload: any) =>
  {
    try
    {
      const response = await getOrderById(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getSegmentsByIdOrderAsync = createAsyncThunk(
  "order/getSegmentsByIdOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await getSegmentsByIdOrder(payload);

      return response;
    } catch (e: any)
    {

      return e?.response;
    }
  }
);



export const getSchemaCosmosAsync = createAsyncThunk(
  "order/getSchemaCosmos",
  async (payload: any) =>
  {
    try
    {
      const response = await getSchemaCosmos(payload);
      return response;
    } catch (e: any)
    {
      // showError(getErrorMsg(e));

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const confirmOrderTaskingAdminAsync = createAsyncThunk(
  "order/confirmOrderTaskingAdmin",
  async (payload) =>
  {
    try
    {
      const response = await confirmOrderTaskingAdmin(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getProductionAsync = createAsyncThunk(
  "order/getProduction",
  async () =>
  {
    try
    {
      const response = await getProduction();
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getProductionSpectralProcessingAsync = createAsyncThunk(
  "order/getProductionSpectralProcessing",
  async () =>
  {
    try
    {
      const response = await getProductionSpectralProcessing();
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const approveOrderAsync = createAsyncThunk(
  "order/approveOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await approveOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const submitOrderAsync = createAsyncThunk(
  "order/submitOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await submitOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);
export const createOrderAsync = createAsyncThunk(
  "order/createOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await createOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const createTaskingOrderAsync = createAsyncThunk(
  "order/createTaskingOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await createTaskingOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getArchiveOrderByIdAsync = createAsyncThunk(
  "order/getArchiveOrderById",
  async (id) =>
  {
    try
    {
      const response = await getArchiveOrderById(id);
      return response;
    } catch (e)
    {
      console.log(e, "error");

      return {};
    }
  }
);

export const getPriorityAsync = createAsyncThunk(
  "exploredataset/getPriority",
  async () =>
  {
    try
    {
      const response = await getPriority();
      return response;
    } catch (e)
    {
      console.log(e, "error");

      return {};
    }
  }
);

export const getMetakeysAsync = createAsyncThunk(
  "order/getMetakeys",
  async (payload: any) =>
  {
    try
    {
      const response = await getMetakeys(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const updateStatusTaskingOrderAsync = createAsyncThunk(
  "order/updateStatusTaskingOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await updateStatusTaskingOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getTaskingSchemaAsync = createAsyncThunk(
  "order/getTaskingSchema",
  async (payload: any) =>
  {
    try
    {
      const response = await getTaskingSchema(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getProviderAsync = createAsyncThunk(
  "order/getProvider",
  async (payload) =>
  {
    try
    {
      const response = await getProvider(payload);
      return response;
    } catch (e)
    {
      return {};
    }
  }
);


export const getSatellitesAsync = createAsyncThunk(
  "order/getSatellites",
  async (payload) =>
  {
    try
    {
      const response = await getSatellites(payload);
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

export const postNotiOrderAsync = createAsyncThunk(
  "order/postNotiOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await postNotiOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const sendQuotationToUserAsync = createAsyncThunk(
  "order/sendQuotationToUser",
  async (payload: any) =>
  {
    try
    {
      const response = await sendQuotationToUser(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const sendPriceToUserAsync = createAsyncThunk(
  "order/sendPriceToUser",
  async (payload: any) =>
  {
    try
    {
      const response = await sendPriceToUser(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const sendToProviderCapellaAsync = createAsyncThunk(
  "order/sendToProviderCapella",
  async (payload: any) =>
  {
    try
    {
      const response = await sendToProviderCapella(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const sendToProviderAsync = createAsyncThunk(
  "order/sendToProvider",
  async (payload: any) =>
  {
    try
    {
      const response = await sendToProvider(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const resendEmailAsync = createAsyncThunk(
  "order/resendEmail",
  async (payload: any) =>
  {
    try
    {
      const response = await resendEmail(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const uploadDataAsync = createAsyncThunk(
  "order/uploadData",
  async (payload: any) =>
  {
    try
    {
      const response = await uploadData(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const addOrderAsync = createAsyncThunk(
  "order/addOrder",
  async (payload: any) =>
  {
    try
    {
      const response = await addOrder(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const getDataUploadAsync = createAsyncThunk(
  "order/getDataUpload",
  async (payload: any) =>
  {
    try
    {
      const response = await getDataUpload(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    changeShowDrawerListImages: (state, action: PayloadAction<boolean>) =>
    {
      state.showDrawerListImages = action.payload;
    },

    changeShowOrderTasking: (state, action: PayloadAction<boolean>) =>
    {
      state.showOrderTasking = action.payload;
    },
    setValuesForm: (state, action: any) =>
    {
      state.valuesForm = action.payload;
    },

    setOrderedProvider: (state, action: any) =>
    {
      state.orderedProvider = action.payload;
    },
    setPolygonOrderTasking: (state, action: any) =>
    {
      state.polygonOrderTasking = action.payload;
    },
    setProviderIdOrder: (state, action: any) =>
    {
      state.providerIdOrder = action.payload;
    },

    setIsFilter: (state, action: any) =>
    {
      state.isFilter = action.payload;
    },

    changeFilterArchive: (state, action: any) =>
    {
      state.filterDrawer = action.payload;
    },

    setNameProviderSelected: (state, action: any) =>
    {
      state.nameProviderSelected = action.payload;
    },
  },
});


export const getSchemaGeneralArchiveAsync = createAsyncThunk(
  "order/getSchemaGeneralArchive",
  async () =>
  {
    try
    {
      const response = await getGeneralFormOrderArchive();
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const {
  changeShowDrawerListImages,
  changeShowOrderTasking,
  setValuesForm,
  setOrderedProvider,
  setPolygonOrderTasking,
  setProviderIdOrder,
  setIsFilter,
  changeFilterArchive,
  setNameProviderSelected,

} = orderSlice.actions;

export default orderSlice.reducer;
